// Which tab of the edit page opens, from the address (backend plan, §6.3).
//
// The tabs are not lazy and the peers are checked again when the page has loaded the test, so the peer tab
// can open first without waiting for anything. It does when the user arrives from a Failed test: the reasons
// are shown there, in the banner and on the rows. A Ready test duplicated and a Created test edited open on
// the first tab as always.

const TAB_PARAM = 'tab'
const PEERS = 'peers'

const TAB_INDEX = {
  criteria: 0,
  [PEERS]: 1,
}

/**
 * The query to give the route that duplicates a test: the peer tab for a Failed one, nothing for the rest.
 * @param {{ status?: string }} test the list item of the test
 * @returns {object|undefined}
 */
export function duplicateRouteQuery(test) {
  return test && test.status === 'Failed' ? { [TAB_PARAM]: PEERS } : undefined
}

/**
 * @param {object} query `$route.query`
 * @param {boolean} isDuplicate whether the page duplicates a test: the parameter means nothing otherwise
 * @returns {number} the index of the tab to open; the first one for anything unknown
 */
export function editTabIndex(query, isDuplicate) {
  const tab = query && query[TAB_PARAM]
  return isDuplicate && Object.prototype.hasOwnProperty.call(TAB_INDEX, tab) ? TAB_INDEX[tab] : 0
}
